import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, GlobalMessageService, GlobalMessageType } from "@spartacus/core";
import { map, take} from "rxjs/operators";
import { ExcelDownloadService } from "src/app/shared/services/excel-download.service";
import { StsAdminService } from "../sts-admin.service";

@Component({
  selector: 'app-sts-customer-upload',
  templateUrl: './sts-customer-upload.component.html',
  styleUrls: ['./sts-customer-upload.component.scss']
})
export class StsCustomerUploadComponent implements OnInit, OnDestroy {
    customerDetails: any = [];
    customerDataSubscription: any;
    file: File;
    data: any;
    disable: boolean;
    fileUploadForm = this.fb.group({
        excelUploadFile: ['']
    });
    excelFileInvalidStatus: boolean = false;
    errorMsg: string;
    baseSiteId: any;

    constructor(
        private readonly stsAdminService: StsAdminService,
        private readonly cd: ChangeDetectorRef,
        public excelService: ExcelDownloadService,
        private modal: NgbModal,
        private readonly fb: FormBuilder,
        private readonly globalMessage: GlobalMessageService,
        private baseSite: BaseSiteService,
    ) {
        this.disable = false;
    }
    ngOnInit(): void {
        this.baseSite.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
        this.stsAdminService.viewCustomerDetails();
        this.customerDataSubscription = this.stsAdminService.customerDetails$.subscribe((res) => {
            if (res !== null) {
                this.customerDetails = res.stsCustomers;
                this.cd.detectChanges();
            }
        })
    }

    downloadExcel() {
        let filePrefix = 'VSH';
        if(this.baseSiteId == 'vax'){
            filePrefix = 'VAX';
        }
        this.stsAdminService.downloadCustomerData()
            .pipe(
                map(res => res['stsCustomers'])
            ).subscribe((res) => {
                let newArr = [];
                if (res && res.length > 0) {
                    newArr = res.map(obj => {
                        return {
                            'Customer Number': obj?.uidNonLeadingZero,
                            'Tier': obj?.tier,
                            'Contract Number': obj?.contractNumber,
                        };
                    });
                }
                this.excelService.exportAsExcelFile(newArr, filePrefix+ '_STS_CustomerUpload_' + new Date(), true);
            });
    }


    hideModal() {
        this.modal.dismissAll();
        this.refreshValue();
    }

    openModal(content) {
        this.modal.open(content, {
            centered: true,
            backdrop: 'static',
            windowClass: `${this.baseSiteId}`
        });
    }

    uploadFileDetails() {
        let selectedFile: File = this.file;
        let formData: FormData = new FormData();
        formData.append('selectedFile', selectedFile, selectedFile.name);
        this.disable = true;
        this.stsAdminService.getUploadFileData(formData).subscribe((res) => {
            if (res.status == 'success') {
                this.hideModal();
                //this.stsAdminService.viewCustomerDetails();
                this.globalMessage.add('Customer upload is in progress. The status will be notified via email', GlobalMessageType.MSG_TYPE_CONFIRMATION);
                this.refreshValue();
                this.disable = false;
            } else {
                this.hideModal();
                this.globalMessage.add('Something went wrong. Please try again', GlobalMessageType.MSG_TYPE_ERROR);
                this.refreshValue();
                this.disable = false;
            }
        })
    }
    onFileSelect(event) {
        this.errorMsg = '';
        if (event.target.files.length > 0) {
            this.file = (event.target as HTMLInputElement).files[0];
            this.fileUploadForm.get('excelUploadFile').setValue(this.file.name);
            const fileParts = this.file.name.split('.');
            const extension = fileParts[fileParts.length - 1].trim().toLowerCase();
            const firstColumnName = 'customer number'
            if (extension === 'xlsx' || extension === 'xls') {
                this.excelService.validateExcelFile(this.file, firstColumnName).subscribe(res => {
                    if (res) {
                        this.excelFileInvalidStatus = false;
                        this.cd.detectChanges();
                    } else {
                        this.globalMessage.add('Customer number is blank or does not exist. Please check the excel', GlobalMessageType.MSG_TYPE_ERROR);
                        this.excelFileInvalidStatus = true;
                        this.cd.detectChanges();
                        this.refreshValue();
                    }
                });
            } else {
                this.errorMsg = "The uploaded file should be xls format."
                this.excelFileInvalidStatus = true;
                this.refreshValue();
            }
        }
    }
    refreshValue() {
        this.fileUploadForm.get('excelUploadFile').setValue('');
        this.cd.detectChanges();
    }

    ngOnDestroy() {
        this.customerDataSubscription?.unsubscribe();
    }

}